export default __webpack_public_path__ + "static/media/default-event-photo.648c7e1b.jpg";